/** 是否是electron环境 */
export const isElectron = navigator.userAgent.includes('Electron')
